import PropTypes from 'prop-types'
import { Spinner } from 'baseui/spinner'

import {
  TableLoadingOverlayWrap,
  TableLoadingContent,
} from './styled-components'

const TableLoadingOverlay = ({ text }) => {
  return (
    <TableLoadingOverlayWrap>
      <TableLoadingContent>
        <Spinner size={32} />
        {text && <span>{text}</span>}
      </TableLoadingContent>
    </TableLoadingOverlayWrap>
  )
}

TableLoadingOverlay.propTypes = {
  text: PropTypes.string,
}

export default TableLoadingOverlay
